export default {
  id: 1, type: '-', iconName: 'shuiguo', text: '水果'
};